// User Reducer types
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const SET_USER = 'SET_USER';
export const LOADING_USER = 'LOADING_USER';
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const FILTER_USER = 'FILTER_USER';
export const LOADING_PERMISTION = 'LOADING_PERMISTION';
export const SET_MESSAGE_PERMISTION = 'SET_MESSAGE_PERMISTION';
export const SET_ERROR_PERMISTION = 'SET_ERROR_PERMISTION';
export const UPDATE_ARTICLES_MANAGER = 'UPDATE_ARTICLES_MANAGER';
export const CLEAR_PERMISTION = 'CLEAR_PERMISTION';

// UI Reducer types checked
export const SET_ERRORS = 'SET_ERRORS';
export const LOADING_UI = 'LOADING_UI';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SET_SUCCESS = 'SET_SUCCESS';
export const CLEAR_SUCCESS = 'CLEAR_SUCCESS';
export const SET_EXPLOGIN = 'SET_EXPLOGIN';

// Data Settings Checked
export const POST_SETTING = 'POST_SETTING';
export const SET_SETTING = 'SET_SET_SETTINGBILL';
export const LOADING_SETTING = 'LOADING_SETTING';
export const SET_BANNER_LEFT = 'SET_BANNER_LEFT';
export const SET_BANNER_RIGHT_TOP = 'SET_BANNER_RIGHT_TOP';
export const SET_BANNER_RIGHT_BOTTOM = 'SET_BANNER_RIGHT_BOTTOM';
export const DELETE_IMAGE_BANNER_LEFT = 'DELETE_IMAGE_BANNER_LEFT';
export const CLEAR_BANNER = 'CLEAR_BANNER';
export const GET_BANNER_LEFT = 'GET_BANNER_LEFT';
export const GET_BANNER_RIGHT_TOP = 'GET_BANNER_RIGHT_TOP';
export const GET_BANNER_RIGHT_BOTTOM = 'GET_BANNER_RIGHT_BOTTOM';

export const LOADING_DATA = 'LOADING_DATA';
export const STOP_LOADING_UI = 'STOP_LOADING_UI';
export const SET_NOTY = 'SET_NOTY';


// Data categories Checked
export const GET_ALL_CATEGORIES_WEB_SYS = 'GET_ALL_CATEGORIES_WEB_SYS';
export const GET_ALL_CATEGORIES_WEB = 'GET_ALL_CATEGORIES_WEB';
export const UPDATE_CATEGORY_WEB = 'UPDATE_CATEGORY_WEB';
export const DELETE_CATEGORY_WEB = 'DELETE_CATEGORY_WEB';
export const POST_CATEGORY_WEB = 'POST_CATEGORY_WEB';
export const SET_CATEGORY = 'SET_CATEGORY';
export const LOADING_CATE = 'LOADING_CATE';
export const CLEAR_IMAGE_SELECTED = 'CLEAR_IMAGE_SELECTED';

//Checked
export const SET_IMAGE_FOLDERS = 'SET_IMAGE_FOLDERS';
export const POST_IMAGE_FOLDER = 'POST_IMAGE_FOLDER';
export const SET_IMAGE_FOLDER = 'SET_IMAGE_FOLDER';
export const SET_IMAGE_FILE = 'SET_IMAGE_FILE';
export const SET_IMAGES_FILE = 'SET_IMAGES_FILE';
export const LOADING_IMAGE = 'LOADING_IMAGE';
export const DELETE_IMAGE_ARRAY = 'DELETE_IMAGE_ARRAY';
export const CLEAR_IMAGE = 'CLEAR_IMAGE';
export const MESSAGE_FROM_IMAGE = 'MESSAGE_FROM_IMAGE';
export const CLEAR_MESSAGE_IMAGE = 'CLEAR_MESSAGE_IMAGE';
export const SUBMIT_UPDATE_IMAGE = 'SUBMIT_UPDATE_IMAGE';
export const SELECT_IMAGE_FILE = 'SELECT_IMAGE_FILE';
export const DELETE_IMAGE_FILE = 'DELETE_IMAGE_FILE';


export const GET_ALL_POSTS = 'GET_ALL_POSTS';
export const POST_ONE_POST = 'POST_ONE_POST';
export const LOADING_POST = 'LOADING_POST';
export const SET_POST = 'SET_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const FILTER_POST = 'FILTER_POST';